const burger = document.getElementById('burger')
const mobileMenu = document.getElementById('mobileMenu')
const body = document.body

// ---- stan ----
let menuOpen = false

// ================================================
//  BURGER – otwieranie / zamykanie
// ================================================
const toggleMenu = (forceClose = false) => {
	menuOpen = forceClose ? false : !menuOpen

	burger.classList.toggle('is-active', menuOpen)
	mobileMenu.classList.toggle('is-open', menuOpen)

	// aria-expanded na burgerze
	burger.setAttribute('aria-expanded', menuOpen)

	// aria-hidden TYLKO gdy menu zamknięte — nigdy gdy jest open i może mieć fokus
	mobileMenu.setAttribute('aria-hidden', !menuOpen)

	// blokada scrolla gdy menu otwarte
	body.style.overflow = menuOpen ? 'hidden' : ''
}

burger?.addEventListener('click', () => toggleMenu())

// ================================================
//  ACCORDION – mobilna lista rozwijana
// ================================================
const accordionTriggers = document.querySelectorAll('.accordion-trigger')

accordionTriggers.forEach(trigger => {
	trigger.addEventListener('click', () => {
		const targetId = trigger.getAttribute('aria-controls')
		const dropdown = document.getElementById(targetId)
		if (!dropdown) return

		const isOpen = dropdown.classList.toggle('is-open')
		trigger.setAttribute('aria-expanded', isOpen)
	})
})

// ================================================
//  ZAMYKANIE po kliknięciu linka w mobile menu
// ================================================
mobileMenu?.querySelectorAll('a').forEach(link => {
	link.addEventListener('click', () => toggleMenu(true))
})

// ================================================
//  ZAMYKANIE kliknięciem poza menu
// ================================================
document.addEventListener('click', e => {
	if (!menuOpen) return
	if (!mobileMenu.contains(e.target) && !burger.contains(e.target)) {
		toggleMenu(true)
	}
})

// ================================================
//  ZAMYKANIE klawiszem Escape
// ================================================
document.addEventListener('keydown', e => {
	if (e.key === 'Escape' && menuOpen) toggleMenu(true)
})
